module.exports = __webpack_public_path__ + "img/harvard-logo.4f8be386.png";